import {
    REQUEST_SUMMARY_LOCATION_NEWBORN,
    RESPONSE_SUMMARY_LOCATION_NEWBORN,
    FAILURE_SUMMARY_LOCATION_NEWBORN,
    NEWBORN_LOCATION_SUMMARY_UPDATE
  } from "../../../actions/types";
  
  const defaultKeywords = ``;
  
  const initialState = {
    isFetching: false,
    isMoreResult: true,
    isMoreResultLoading: false,
    results: [],
    locationResults: [],
    error: false,
    isInitialScreen: true,
    keyword: defaultKeywords,
    size: 10,
    from: 0,
    activePage: 1,
    totalCountries: 0,
    totalExperts: 0,
    terms: "",
    country: "",
    experts: [],
    university: [],
    shortlist: "yes",
    year: "",
    activeSortItem: { value: "citation_count", label: "Total Related Citation" },
    operator: "AND"
  };
  
  const setRequest = (state, action) => {
    const {
      terms = "",
      country = "",
      experts = [],
      university = [],
      shortlist = "no",
      year = "",
      operator = ""
    } = action.payload;
  
    let keyword = terms.split(",");
    keyword = keyword.join(", ");
  
    return {
      ...state,
      isFetching: true,
      error: false,
      isInitialScreen: false,
      results: [],
      locationResults: [],
      experts,
      country,
      terms,
      university,
      keyword: keyword ? keyword : defaultKeywords,
      shortlist,
      year,
      operator
    };
  };
  
  const setFailure = (state, action) => {
    return {
      ...state,
      isFetching: false,
      error: true,
      isInitialScreen: false,
      results: [],
      keyword: "",
      totalCountries: 0,
      totalAffiliations: 0,
      activeSortItem: {
        value: "citation_count",
        label: "Total Related Citation"
      },
      terms: "",
      country: "",
      experts: [],
      university: [],
      shortlist: "yes",
      operator: ""
    };
  };
  
  const setResponse = (state, action) => {
    let {
      results = [],
      totalCountries = 0,
      totalAffiliations = 0,
      activePage,
      activeSortItem,
      locationResults,
      totalExperts = 0
    } = action.payload;
    return {
      ...state,
      isFetching: false,
      error: false,
      results: results,
      locationResults: locationResults,
      isInitialScreen: false,
      totalCountries,
      totalAffiliations,
      totalExperts,
      activePage,
      activeSortItem
    };
  };
  
  
  const updateFilter = (state, action) => {
    const { terms, country, shortlist } = action.payload;
    return {
      ...state,
      terms: terms,
      country: country,
      shortlist: shortlist
    };
  };
  export default (state = initialState, action) => {
    switch (action.type) {
      case RESPONSE_SUMMARY_LOCATION_NEWBORN:
        return setResponse(state, action);
        break;
  
      case FAILURE_SUMMARY_LOCATION_NEWBORN:
        return setFailure(state, action);
        break;
  
      case REQUEST_SUMMARY_LOCATION_NEWBORN:
        return setRequest(state, action);
      
      case NEWBORN_LOCATION_SUMMARY_UPDATE:
        return updateFilter(state, action);
  
      default:
        return state;
        break;
    }
  };
  